import { H6, Text } from "@adfenix/alexandria";
import { TemplateUiModel } from "routes/back-office/program-builder/details/campaign/meta/template/TemplateUiModel";
import { Row, Col } from "react-grid-system";

export type TemplateUiModelWithAdType = TemplateUiModel & { type: "ad" };
interface Props {
  template: TemplateUiModelWithAdType;
}

const checkIfTemplateUiModel = (
  template: TemplateUiModelWithAdType
): template is TemplateUiModelWithAdType => {
  return (
    template.hasOwnProperty("type") &&
    (template as TemplateUiModel).channels.includes("Facebook")
  );
};

export const TemplateContent = ({ template }: Props) => {
  return (
    <Row>
      <Col>
        <H6>Ad message</H6>
        <Text size="m">{template.message}</Text>
      </Col>

      {checkIfTemplateUiModel(template) ? (
        <>
          <Col>
            <H6>Ad headline</H6>
            <Text size="m">{template.headline}</Text>
          </Col>
          <Col>
            <H6>Ad description</H6>
            <Text size="m">{template.description}</Text>
          </Col>
        </>
      ) : null}
    </Row>
  );
};
